import { HeaderFactory } from '@modules/tours/table-toolkit/classes/header-factory';
import { DateHeader } from './date-header';

export class NightDateHeaderFactory extends HeaderFactory<Date, number> {
  getColHeader(items: Date[]): DateHeader {
    return new DateHeader(items);
  }
}
